import { useState } from 'react'
import { InsuranceIcon } from 'src/components/Icons/InsuranceIcon'
import { formatterPrice } from 'src/utils/formatterPrice'

import ModalLearnMoreBikeInsurance from './ModalLearnMoreBikeInsurance/ModalLearnMoreBikeInsurance'
import { useProductPageContext } from '../../../contexts'
import { useInsurancePrice } from './hooks/useInsurancePrice'

interface CmsSections {
  id: string
  name: string
  data: Record<string, unknown>
}

type LearnMoreBikeInsuranceMobileProps = {
  cmsData?: {
    name: string
    sections?: CmsSections[]
  }
}

export const LearnMoreBikeInsuranceMobile = ({
  cmsData,
}: LearnMoreBikeInsuranceMobileProps) => {
  const [open, setOpen] = useState(false)
  const { product, currentSku } = useProductPageContext()
  const isBike = product?.categories?.find(
    (cat: string) => cat === '/Equipamentos/Bicicletas/'
  )

  const skuBikePrice = currentSku?.sellerDefault?.sellerOffer?.price ?? 0

  // Busca o preço do seguro
  const { insurancePrice } = useInsurancePrice(skuBikePrice, !!isBike)

  if (!isBike) {
    return null
  }

  // Se não houver seguro disponível, mostra apenas a mensagem
  if (!insurancePrice) {
    return (
      <div className="w-full bg-[#F5F4F5] p-6 my-9 sm:hidden rounded">
        <p className="text-sm text-[#101010] text-center font-bold">
          Não há seguros disponíveis para o valor da sua bike.
        </p>
      </div>
    )
  }

  return (
    <div className="relative w-full bg-[#F5F4F5] p-6 my-9 sm:hidden flex items-start justify-between rounded">
      <div className="flex items-start gap-3 w-full">
        <div className="mt-1">
          <InsuranceIcon />
        </div>
        <div>
          <h3 className="text-sm font-medium text-[#101010]">
            Adicione Seguro Bike <br /> 12 meses
          </h3>
          <p className="text-xs text-[#101010] mt-1">
            A partir de {formatterPrice(insurancePrice)} à vista <br />
            Consulte as opções de parcelamento
          </p>
        </div>
      </div>
      <button
        className="absolute right-5 top-[22px] text-sm text-[#101010] underline font-medium"
        onClick={() => setOpen(true)}
      >
        Saiba mais
      </button>
      <ModalLearnMoreBikeInsurance
        isOpen={open}
        onDismiss={() => setOpen(false)}
        cmsData={cmsData}
      />
    </div>
  )
}
